export default {
  components: {
    FITTimepicker:{
      placeholder:"Select Time",
    },
    fitWorkflowProgress: {
      next: 'Next',
      previous: 'Previous'
    },

    FITFileUpload: {
      select: 'Select Files',
      upload: 'Upload Files',
      fileName: 'File Name',
      size: 'Size',
      publicDocument: 'Public Document',
      isPublic: 'Public',
      documentTag: 'Document Tag',
      remarks: 'Remarks',
      isDownloadable: 'is Downloadable',
      remove: 'Remove',
      dropFileMsg: 'Drop files & folders below to upload',
      uploadRemindMsg: 'Please do remember press "Upload Files" after files selected',
      successMsg: 'Your files had been uploaded successfully',
      errorMsg: 'Your files uploaded failed. Please try again later',
      oversizeMsg:"The uploaded files size over the maximum size",
    },
    FITOutstandingRequirement: {
      general: {
        ID: 'ID',
        type: 'Type',
        clientID: 'Client ID',
        submitBtn: 'Submit',
        lastUpdate: 'Last Update',
        replys: 'Replys',
        createAgent: 'Create Agent',
        createTime: 'Create Time',
        updateTime: 'Update Time',
        subject: 'Subject',
        status: 'Status',
        caseID: 'Case ID',
        caseActionPrefix: 'Confrim to',
        caseActionPostfix: 'outstanding requirement case',
        fileDownloadErrorMsg: 'Please allow "Popup Window" for document downloading',
      },
      createCase: {
        title: 'Create Case',
        header: 'Create Outstanding Requirement',
        description: 'Description',
        confirmMsg: 'Confirm to create outstanding requirement ?',
        errorMsg: 'Create Outstanding Requirement failed. Please try again later.',
      },
      caseHistory: {
        title: 'Case History',
        header: 'Outstanding Requirement History',
        createBtn: 'Create Case',
        noDataMsg: 'No Case History',
      },
      caseDetail: {
        title: 'Case Detail',
        header: 'Outstanding Requirement Detail',
        errorMsg: 'Reply Submit failed. Please try again later.',
        information: 'Information',
        correspondence: 'Correspondence',
        documents: 'Documents',
        comfirmReplyMsg: 'Confirm to submit reply ?',
        replyBtn: 'Reply',
        closeBtn: 'Close Case',
        acceptBtn: 'Accept Case',
        rejectBtn: 'Reject Case',



      },
    },

  }
}



// WEBPACK FOOTER //
// ./src/components/langs/en_us/index.js